import Tabs from './components/Tabs';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'tabs',
  pluginComponent: Tabs,
});
